<script lang="ts">
  export let direction: string = 'left';
  let directionClass: string = '';

  switch (direction) {
    case 'right':
      directionClass = 'rotate-180';
      break;
  }
</script>

<svg class={directionClass} width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.83 10H4.17m0 0L10 15.83M4.17 10 10 4.17"
    stroke="#667085"
    stroke-width="1.67"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
